export const gradient = [
	{
		color: '#eab06b',
		ratio: 0,
	},
	{
		color: '#eab06b',
		ratio: 0.03,
	},
	{
		color: '#fcf3d3',
		ratio: 0.6,
	},
	{
		color: '#eab06b',
		ratio: 0.97,
	},
	{
		color: '#eab06b',
		ratio: 1,
	},
];



// WEBPACK FOOTER //
// ./src/store/ActivityPage/modules/config.js